import css from '../components/root-layout/root-layout.css';


const mobileScreenBreakpoint = parseInt(css['mobileScreenBreakpoint'], 10);

export type Platform = 'mobile_view' | 'web';

export function getPlatform(): Platform {
  if (typeof window === 'undefined') {
    return 'web';
  }
  return window.innerWidth <= mobileScreenBreakpoint ? 'mobile_view' : 'web';
}
